import { Component, OnInit, Input, Output, EventEmitter, Optional } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';

import { ToastrService } from 'ngx-toastr';

import { CaseItemizedStatements, CaseItemizedStatementsProvider } from '@app/data/cases/models';
import { LookupService } from '@app/settings/services';
import { LookupValue } from '@app/settings/models';

import { Messages } from '@app/constants';

import { faXmark, faPlus } from '@fortawesome/pro-solid-svg-icons';

@Component({
	selector: 'app-create-itemized-statements',
	templateUrl: 'create-itemized-statements.component.html',
	styleUrls: ['create-itemized-statements.component.scss'],
	viewProviders: [{
		provide: ControlContainer,
		deps: [[Optional, NgForm]],
		useFactory: (ngForm: NgForm) => ngForm
	}]
})
export class CaseCreateItemizedStatementsComponent implements OnInit {
	faXmark = faXmark;
	faPlus = faPlus;

	showAddProviderForm: boolean = false;
	addProviderModel: CaseItemizedStatementsProvider;

	@Input()
	case: CaseItemizedStatements;

	@Output()
	caseChange: EventEmitter<CaseItemizedStatements> = new EventEmitter<CaseItemizedStatements>();

	constructor(
		private lookupService: LookupService,
		private toastrService: ToastrService
	) {
	}

	ngOnInit() {
		this.onReloadGenders();
	}

	loadingGenders: boolean = false;
	genders: LookupValue[];
	async onReloadGenders() {
		try {
			this.loadingGenders = true;

			this.genders = await this.lookupService.getLookupValues('Gender');
		} catch (error: any) {
			this.toastrService.error(Messages.ErrorRetry, `Failed to Load Genders.`);
		} finally {
			this.loadingGenders = false;
		}
	}

	async onShowAddProviderForm() {
		this.addProviderModel = new CaseItemizedStatementsProvider();
		this.showAddProviderForm = true;
	}

	async onHideAddProviderForm() {
		this.showAddProviderForm = false;
	}

	async onAddProvider() {
		if (!this.case.providers) {
			this.case.providers = [];
		}

		this.case.providers.push({
			...this.addProviderModel
		});

		this.onHideAddProviderForm();
	}

	async onRemoveProvider(provider: CaseItemizedStatementsProvider) {
		this.case.providers.splice(this.case.providers.indexOf(provider), 1);
	}
}
